import { FormSchemaDropdownInput } from "#src/batteries-included-components/Dropdowns/FormSchemaDropdownInput";
import { Form, useForm } from "@validereinc/common-components";
import { produce } from "immer";
import React, { useEffect } from "react";
import { useWorkflowConfigurationFormStore } from "../WorkflowConfigurationFormStore";
import WorkflowConfigurationSingleFormChoice from "./WorkflowConfigurationSingleFormChoice";

const WorkflowConfigurationFormChoiceDetails = () => {
  const { setFormChoice, setFormChoiceIsValid, getFormChoice } =
    useWorkflowConfigurationFormStore();

  const storeValues = getFormChoice();

  const form = useForm({
    values: { form_schema_id: storeValues?.form_schema_id ?? "" },
  });

  useEffect(() => {
    setFormChoiceIsValid(form.formState.isValid);
  }, [form.formState.isValid, setFormChoiceIsValid]);

  return (
    <>
      <Form
        {...form}
        style={{ maxWidth: 432 }}
      >
        <FormSchemaDropdownInput
          name="form_schema_id"
          label="Form Template"
          isMulti={false}
          fetchFilters={{ status: "active" }}
          isRequired
          isDisabled // This is disabled because changing the form template will reset the choices and we don't handle dynamic edge/node updates yet.
          onChange={(formSchemaId: string) => {
            if (storeValues) {
              setFormChoice({
                ...storeValues,
                form_schema_id: formSchemaId,
              });
            }
          }}
        />
      </Form>
      {(storeValues?.choices ?? []).map((choice, idx) => (
        <WorkflowConfigurationSingleFormChoice
          index={idx}
          choice={choice}
          formSchemaId={storeValues?.form_schema_id ?? ""}
          key={idx}
          onChange={(formValues) => {
            if (storeValues) {
              setFormChoice(
                produce(storeValues, (draft) => {
                  draft.choices[idx] = formValues;
                })
              );
            }
          }}
        />
      ))}
    </>
  );
};

export default WorkflowConfigurationFormChoiceDetails;
